import { getCookie, setCookie } from '@calm/web-common/dist/cookies';
import { useCallback } from 'react';

export const useAgeGenderStepStatus = () => {
    const setHasCompletedAgeGenderStep = useCallback(
        (value = 'true') => setCookie('ags', value, 15),
        []
    );
    const getHasCompletedAgeGenderStep = useCallback(
        () => getCookie('ags'),
        []
    );
    const clearHasCompletedAgeGenderStep = useCallback(
        () => setCookie('ags', 'false', 0),
        []
    );

    return {
        setHasCompletedAgeGenderStep,
        getHasCompletedAgeGenderStep,
        clearHasCompletedAgeGenderStep,
    };
};
